var env = "development" || 'local';

//var DEV_TOKEN = 'ac4a052bd7a19d79766d3bb52e53c8ef';
//var LIVE_TOKEN = '41de22f20a5d1494d4faa88009465280';

var mixpanel = require('mixpanel-browser');

//var mixpanelToken = DEV_TOKEN;
var mixpanelConfig = {
    ignore_dnt: true
}

/*
if (env === 'production') {
    mixpanelToken = LIVE_TOKEN;
}
*/

// Mixpanel interface for Unity Client
var Mixpanel = module.exports = {
    initialize: function (event){

        const parsedData = JSON.parse(event);
        mixpanel.init(parsedData.token, mixpanelConfig);
    },

    trackEvent: function (event) {
        //console.log('----- TRACK EVENT -----');
        //console.log('Event:', event);
        //console.log('Event Properties:', JSON.stringify(event, null, 2));

        const parsedData = JSON.parse(event);
        //console.log('Parsed Event Data:', JSON.stringify(parsedData, null, 2));

        return mixpanel.track(parsedData.eventName, parsedData.properties, function (response) {
            //console.log('TRACK RESPONSE:',  JSON.stringify(response, null, 2));
            if (response === 0) {
                console.log('TRACK EVENT ERROR: response ', response);
                return false;
            }
            //console.log('TRACK EVENT SUCCESS');
            return true;
        });
    },

    timeEvent: function (event) {
        //console.log('----- TIME EVENT -----');
        //console.log('Event:', event);

        const parsedData = JSON.parse(event);
        //console.log('Parsed Event Data:', JSON.stringify(parsedData, null, 2));

        mixpanel.time_event(parsedData.eventName);
        return true;
    },

    trackCharge: function(event) {
        console.log('----- TRACKING CHARGE -----');
        console.log('Event:', event);

        const parsedData = JSON.parse(event);
        console.log('Parsed Event Data:', JSON.stringify(parsedData, null, 2));

        mixpanel.people.track_charge(parsedData.amount, parsedData.properties)
    },

    identify: function (event) {
        //console.log('----- IDENTIFY EVENT -----');
        //console.log('Event:', event);

        const parsedData = JSON.parse(event);
        //console.log('Parsed Event Data:', JSON.stringify(parsedData, null, 2));

        mixpanel.identify(parsedData.uniqueID);
        return true;
    },

    peopleSet: function(event) {
        console.log('----- PEOPLE SET -----');
        console.log('Event:', event);

        const parsedData = JSON.parse(event);
        console.log('Parse Event Data:', JSON.stringify(parsedData, null, 2));

        mixpanel.people.set(parsedData.propertyName, parsedData.value);
    },

    register: function (event) {
        //console.log('----- REGISTER EVENT -----');
        //console.log('Event:', event);

        const parsedData = JSON.parse(event);
        //console.log('Parsed Event Data:', JSON.stringify(parsedData, null, 2));

        mixpanel.register(parsedData);
        return true;
    }
};

global.Mixpanel = Mixpanel;
